import React from 'react';

import styles from '../index.module.scss';
import { DATA_TEST_IDS } from '../consts';

import { ImagePreviewProps } from './types';

export const ImagePreview: React.FC<ImagePreviewProps> = ({ url }) => (
  <div className={styles.content}>
    <img
      data-testid={DATA_TEST_IDS.IMAGE}
      alt=""
      src={url}
    />
  </div>
);
